import {
  OlegHttps,
  OlegHttp,
  KonstantinMasterHttps,
  ArtemOrdersHttps,
} from '../fetchUrls';
import currentHeaders, { getSpace } from './headers';
import dayjs from 'dayjs';
import { msToLocalDate } from './constant';
import { filter } from 'lodash';

// Запрос прерван
const handleRequestError = (error) => {

  if (error?.name === 'AbortError' ||
    error?.code === 'ERR_CANCELED' ||
    error?.message?.includes('aborted')) {
    console.log('signal is aborted without reason');
    return;
  }
  console.error(error);
};

// Функция для получения значений фильтров
export const getValueMultiFilter = (filter) => {
  if (Array.isArray(filter)) {
    return filter?.length > 0 ? filter.map((item) => item.value) : ['all'];
  } else {
    return filter?.value ? [filter?.value] : ['all']
  }
}

// Отмена запросов
export class RequestController {
  constructor() {
    this.controllers = new Map();
  }

  abort(key) {
    if (this.controllers.has(key)) {
      this.controllers.get(key).abort();
      this.controllers.delete(key);
    }
  }

  createController(key) {
    this.abort(key); // Отменяем предыдущий запрос с таким же ключом
    const controller = new AbortController();
    this.controllers.set(key, controller);
    return controller;
  }

  removeController(key) {
    this.controllers.delete(key);
  }

  abortAll() {
    for (const controller of this.controllers.values()) {
      controller.abort();
    }
    this.controllers.clear();
  }
}

export const setDataFromJson = (
  json,
  page,
  setState,
  withAll = true,
  mapFunc = (el) => ({ label: el.name, value: el.id })
) => {
  const dataArr = json.map(mapFunc);
  if (page > 1) {
    setState((prev) => [...prev, ...dataArr]);
  } else {
    if (withAll) setState([...dataArr]);
    else setState([...dataArr]);
  }
};

export const fetchApiReviewsFilter = ({
  selectedSpace,
  page = 1,
  setApiData,
  selectedMarketplace,
  withAll = true,
  setTotal
}) => {
  let url = `${KonstantinMasterHttps}/feedbacks-and-questions/filters/api-ids`;

  const body = JSON.stringify({
    page,
    limit: 50,
    mp_id_list: Array.isArray(selectedMarketplace)
      ? selectedMarketplace?.length === 0
        ? ['all']
        : selectedMarketplace?.map((el) => el?.value)
      : selectedMarketplace?.value
        ? [selectedMarketplace?.value]
        : ['all'],
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      setDataFromJson((json?.filter_data || json), page, setApiData, withAll)
    })
    .catch(handleRequestError);
};

export const fetchFilterLaModa = ({
  controller,
  selectedSpace,
  page = 1,
  set,
  selectedApi = [],
  searchParam = null,
  filter,
  setTotal
}) => {

  let url = `${OlegHttps}/api/v1/lamoda/filter/${filter}`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    market_name_list: getValueMultiFilter(selectedApi),
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = json?.filter_data.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError)
};

export const fetchApiFilterPivot = ({
  selectedSpace,
  page = 1,
  set,
  selected_id_list,
  searchParam = '',
  filter,
  setTotal
}) => {
  let url = `https://apps1.ecomru.ru:4450/api/v1/pivot/filter/${filter}`

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    selected_id_list,
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = json?.filter_data.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError);
};

export const fetchApiFilterVer3 = ({
  controller,
  selectedSpace,
  page = 1,
  set,
  selectedApi = [],
  selectedCategory = [],
  selectedBrand = [],
  selectedShop = [],
  selectedCampaign = [],
  searchParam = null,
  filter,
  selected_id_list,
  setTotal
}) => {

  // let url = `${OlegHttps}/api/v3/filter/${filter}`;
  // - старый запрос

  let url = `https://apps0.ecomru.ru:4420/api/v1/filter/${filter}`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    api_id_list: getValueMultiFilter(selectedApi),
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    // product_id_list: getValueMultiFilter(selectedProduct),
    selected_id_list,
    shop_id_list: getValueMultiFilter(selectedShop),
    campaign_id_list: getValueMultiFilter(selectedCampaign),
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = json?.filter_data.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError)
};

// Фильтр для биддера
export const fetchPaymentTypeFilter = ({
  controller,
  selectedSpace,
  page = 1,
  set,
  selectedShop = [],
  setTotal
}) => {

  let url = `https://apps1.ecomru.ru:4450/api/v1/strategies/payment_type/filter`;

  const body = JSON.stringify({
    mp_id: selectedShop?.value,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = (json?.filter_data || json)?.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError)
};

// Фильтр для уведомления ошибок
export const fetchNotificationsError = ({
  controller,
  selectedSpace,
  page = 1,
  set,
  searchParam,
  setTotal
}) => {

  let url = `https://apps1.ecomru.ru:4455/error-notifications/services`;

  const body = JSON.stringify({
    limit: 50,
    page,
    search_param: searchParam.length < 1 ? null : searchParam,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = (json?.filter_data || json)?.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError)
};

// Фильтр посмотреть конкурентов
export const fetchFilterCompetitorsView = ({
  controller,
  selectedSpace,
  page = 1,
  set,
  selectedCategory = [],
  selectedBrand = [],
  selectedShop = [],
  searchParam = null,
  filter,
  selected_id_list,
  setTotal
}) => {

  let url = `https://apps1.ecomru.ru:4450/api/v2/competitors_view/filter/${filter}`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    mp_name_list: getValueMultiFilter(selectedShop),
    category_name_list: getValueMultiFilter(selectedCategory),
    brand_name_list: getValueMultiFilter(selectedBrand),
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = json?.filter_data.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError)
};

// Фильтр для lens
export const fetchApiFilterLens = ({
  controller,
  selectedSpace,
  page = 1,
  set,
  selectedApi = [],
  selectedCategory = [],
  selectedBrand = [],
  selectedProduct = [],
  selectedShop = [],
  selectedCampaign = [],
  searchParam = null,
  selected_id_list,
  setTotal
}) => {

  let url = 'https://apps1.ecomru.ru:4450/api/v1/lense/filter/brand_name_list'

  let product_id_list

  if (selectedProduct?.length > 0) {
    product_id_list = selectedProduct.map((el) => el.value);
  } else {
    product_id_list = ['all'];
  }

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    api_id_list: getValueMultiFilter(selectedApi),
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    //  product_id_list,
    selected_id_list,
    shop_id_list: getValueMultiFilter(selectedShop),
    campaign_id_list: getValueMultiFilter(selectedCampaign),
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = json?.filter_data.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError)
};

// Фильтр для себестоимости
export const fetchCostFilter = ({
  controller,
  selectedSpace,
  page = 1,
  set,
  searchParam = null,
  selected_id_list,
  setTotal
}) => {
  let url = 'https://apps1.ecomru.ru:4450/api/v1/cost/filter/margin_filter'

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    selected_id_list,
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = json?.filter_data.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError)
};

// Фильтр для Low-Hight в аналитике
export const fetchApiFilterSummary = ({
  controller,
  selectedSpace,
  page = 1,
  set,
  searchParam = null,
  selected_id_list,
  setTotal
}) => {
  let url = 'https://apps1.ecomru.ru:4450/api/v1/low_high/filter/group_list_filter'

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    selected_id_list,
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      if (json) {
        const dataArr = json?.filter_data.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
};

// Multon по баннерам
export const fetchFilterMulton = ({
  selectedSpace,
  page = 1,
  set,
  selectedCategory,
  selectedBrand,
  selectedShop,
  searchParam = null,
  selectedAddress,
  selectedAdvertType,
  selectedBannerName,
  selectedBannerType,
  setSelectedFilter,
  append = false,
  withAll = true,
  type = 'union',
  setFilterData,
  filter,
  selected_id_list,
  setTotal
}) => {
  let url = `${OlegHttps}/api/v1/multon/filter/${filter}`;

  let category_id_list,
    brand_id_list,
    shop_id_list,
    campaign_id_list,
    address,
    advert_type,
    banner_name,
    banner_type

  const selectedIds =
    selected_id_list && selected_id_list.length > 0
      ? selected_id_list.flatMap((id) =>
        typeof id === 'string' ? id.split(';') : id
      )
      : [];

  if (selectedCategory?.length > 0) {
    category_id_list = selectedCategory.map((el) => el.value);
  } else {
    category_id_list = ['all'];
  }

  if (selectedBrand?.length > 0) {
    brand_id_list = selectedBrand.map((el) => el.value);
  } else {
    brand_id_list = ['all'];
  }

  if (selectedShop?.length > 0) {
    shop_id_list = selectedShop.map((el) => el.value);
  } else {
    shop_id_list = ['all'];
  }

  if (selectedAddress?.length > 0) {
    address = selectedAddress.map((el) => el.value);
  } else {
    address = ['all'];
  }

  if (selectedAdvertType?.length > 0) {
    advert_type = selectedAdvertType.map((el) => el.value);
  } else {
    advert_type = ['all'];
  }

  if (selectedBannerName?.length > 0) {
    banner_name = selectedBannerName.map((el) => el.value);
  } else {
    banner_name = ['all'];
  }

  if (selectedBannerType?.length > 0) {
    banner_type = selectedBannerType.map((el) => el.value);
  } else {
    banner_type = ['all'];
  }

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    shop_name: shop_id_list,
    category_name: category_id_list,
    brand_name: brand_id_list,
    selected_id_list: selectedIds,
    advert_type,
    banner_name,
    address,
    banner_type,
    campaign_id_list,
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      const data = json
      if (setTotal && json?.total) setTotal(json?.total)
      const formattedData = data.filter_data?.map((item) => ({
        label: item.name,
        value: item.id,
      }));

      let selectedItems = []

      if (data.selected?.length) {
        selectedItems = data.selected.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        if (page === 1) {
          setSelectedFilter(selectedItems);
        }
      }

      // set((prevData) =>
      //   !append ? [...prevData, ...formattedData, ...selectedItems] : formattedData
      // );

      // const dataArr = json?.filter_data.map((el) => ({
      //   label: el.name,
      //   value: el.id,
      // }));
      if (page > 1) {
        set((prev) => [...prev, ...formattedData]);
      } else {
        set(formattedData);
      }
    })
    .catch(handleRequestError);
};

// Multon по ключевым словам
export const fetchFilterMultonKeyword = ({
  selectedSpace,
  page = 1,
  set,
  selectedCategory,
  selectedBrand,
  selectedShop,
  searchParam = null,
  selectedAddress,
  selectedKeywords,
  selectedProduct,
  selectedDevice,
  setSelectedFilter,
  date = [],
  filter,
  selected_id_list,
  setTotal
}) => {
  let url = `${OlegHttps}/api/v1/multon/query/filter/${filter}`;

  let [date_from, date_to] = date;

  let category_id_list,
    brand_id_list,
    shop_id_list,
    campaign_id_list,
    address,
    query,
    product_name,
    device

  const selectedIds =
    selected_id_list && selected_id_list.length > 0
      ? selected_id_list.flatMap((id) =>
        typeof id === 'string' ? id.split(';') : id
      )
      : [];

  if (selectedCategory?.length > 0) {
    category_id_list = selectedCategory.map((el) => el.value);
  } else {
    category_id_list = ['all'];
  }

  if (selectedBrand?.length > 0) {
    brand_id_list = selectedBrand.map((el) => el.value);
  } else {
    brand_id_list = ['all'];
  }

  if (selectedShop?.length > 0) {
    shop_id_list = selectedShop.map((el) => el.value);
  } else {
    shop_id_list = ['all'];
  }

  if (selectedAddress?.length > 0) {
    address = selectedAddress.map((el) => el.value);
  } else {
    address = ['all'];
  }

  if (selectedKeywords?.length > 0) {
    query = selectedKeywords.map((el) => el.value);
  } else {
    query = ['all'];
  }

  if (selectedProduct?.length > 0) {
    product_name = selectedProduct.map((el) => el.value);
  } else {
    product_name = ['all'];
  }

  if (selectedDevice?.length > 0) {
    device = selectedDevice.map((el) => el.value);
  } else {
    device = ['all'];
  }

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    shop_name: shop_id_list,
    category_name: category_id_list,
    brand_name: brand_id_list,
    selected_id_list: selectedIds?.[0] ? selectedIds : [],
    query,
    product_name,
    address,
    device,
    campaign_id_list,
    limit: 50,
    date_from: dayjs(date_from).format('YYYY-MM-DD'),
    date_to: dayjs(date_to).format('YYYY-MM-DD'),
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      const data = json
      if (setTotal && json?.total) setTotal(json?.total)
      const formattedData = data.filter_data?.map((item) => ({
        label: item.name,
        value: item.id,
      }));

      let selectedItems = []

      if (data.selected?.length) {
        selectedItems = data.selected.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        if (page === 1) {
          setSelectedFilter(selectedItems);
        }
      }

      if (page > 1) {
        set((prev) => [...prev, ...formattedData]);
      } else {
        set(formattedData);
      }
    })
    .catch(handleRequestError);
};

// Multon media
export const fetchFilterMedia = ({
  selectedSpace,
  page = 1,
  set,
  selectedShop,
  searchParam = null,
  selectedAdvertiser,
  selectedBannerDesc,
  selectedLinkDesc,
  setSelectedFilter,
  selectedCategory,
  selectedBrand,
  date,
  filter,
  selected_id_list,
  setTotal
}) => {
  let url = `${OlegHttps}/api/v1/multon/media/filter/${filter}`;

  let [date_from, date_to] = date;

  let shop_id_list,
    link_desc,
    banner_desc,
    advertiser,
    category_name,
    brand_name

  const selectedIds =
    selected_id_list && selected_id_list.length > 0
      ? selected_id_list.flatMap((id) =>
        typeof id === 'string' ? id.split(';') : id
      )
      : [];

  if (selectedCategory?.length > 0) {
    category_name = selectedCategory.map((el) => el.value);
  } else {
    category_name = ['all'];
  }

  if (selectedBrand?.length > 0) {
    brand_name = selectedBrand.map((el) => el.value);
  } else {
    brand_name = ['all'];
  }

  if (selectedShop?.length > 0) {
    shop_id_list = selectedShop.map((el) => el.value);
  } else {
    shop_id_list = ['all'];
  }

  if (selectedAdvertiser?.length > 0) {
    advertiser = selectedAdvertiser.map((el) => el.value);
  } else {
    advertiser = ['all'];
  }

  if (selectedBannerDesc?.length > 0) {
    banner_desc = selectedBannerDesc.map((el) => el.value);
  } else {
    banner_desc = ['all'];
  }

  if (selectedLinkDesc?.length > 0) {
    link_desc = selectedLinkDesc.map((el) => el.value);
  } else {
    link_desc = ['all'];
  }


  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    shop_name: shop_id_list,
    shop_id_list,
    link_desc,
    banner_desc,
    advertiser,
    category_name,
    brand_name,
    selected_id_list: selectedIds?.[0] ? selectedIds : [],
    limit: 50,
    page,
    date_from: dayjs(date_from).format('YYYY-MM-DD'),
    date_to: dayjs(date_to).format('YYYY-MM-DD'),
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      const data = json
      if (setTotal && json?.total) setTotal(json?.total)
      const formattedData = data.filter_data?.map((item) => ({
        label: item.name,
        value: item.id,
      }));

      let selectedItems = []

      if (data.selected?.length) {
        selectedItems = data.selected.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        if (page === 1) {
          setSelectedFilter(selectedItems);
        }
      }
      if (page > 1) {
        set((prev) => [...prev, ...formattedData]);
      } else {
        set(formattedData);
      }
    })
    .catch(handleRequestError);
};

// Multon Перфоманс
export const fetchFilterMultonPerformance = ({
  selectedSpace,
  page = 1,
  set,
  selectedCategory,
  selectedBrand,
  selectedShop,
  searchParam = null,
  selectedAddress,
  selectedColor,
  selectedSize,
  selectedKeywords,
  setSelectedFilter,
  selectedDevice,
  date,
  filter,
  selected_id_list,
  setTotal
}) => {
  let url;
  if (!window.location.hostname.match('localhost')) {
    url = `${OlegHttps}/api/v1/multon/performance/filter/${filter}`;
  } else {
    url = `${OlegHttp}/api/v1/multon/performance/filter/${filter}`;
  }

  let [date_from, date_to] = date;

  let shop_name,
    brand_name,
    category_name,
    size_id,
    color_id,
    query,
    address,
    device

  const selectedIds =
    selected_id_list && selected_id_list.length > 0
      ? selected_id_list.flatMap((id) =>
        typeof id === 'string' ? id.split(';') : id
      )
      : [];

  if (selectedCategory?.length > 0) {
    category_name = selectedCategory.map((el) => el.value);
  } else {
    category_name = ['all'];
  }

  if (selectedBrand?.length > 0) {
    brand_name = selectedBrand.map((el) => el.value);
  } else {
    brand_name = ['all'];
  }

  if (selectedShop?.length > 0) {
    shop_name = selectedShop.map((el) => el.value);
  } else {
    shop_name = ['all'];
  }

  if (selectedAddress?.length > 0) {
    address = selectedAddress.map((el) => el.value);
  } else {
    address = ['all'];
  }

  if (selectedDevice?.length > 0) {
    device = selectedDevice.map((el) => el.value);
  } else {
    device = ['all'];
  }

  if (selectedKeywords?.length > 0) {
    query = selectedKeywords.map((el) => el.value);
  } else {
    query = ['all'];
  }

  if (selectedColor?.length > 0) {
    color_id = selectedColor.map((el) => el.value);
  } else {
    color_id = ['all'];
  }

  if (selectedSize?.length > 0) {
    size_id = selectedSize.map((el) => el.value);
  } else {
    size_id = ['all'];
  }

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    selected_id_list: selectedIds?.[0] ? selectedIds : [],
    shop_name,
    brand_name,
    category_name,
    size_id,
    color_id,
    query,
    address,
    device,
    limit: 50,
    page,
    date_from: dayjs(date_from).format('YYYY-MM-DD'),
    date_to: dayjs(date_to).format('YYYY-MM-DD'),
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      const data = json
      if (setTotal && json?.total) setTotal(json?.total)
      const formattedData = data.filter_data?.map((item) => ({
        label: item.name,
        value: item.id,
      }));

      let selectedItems = []

      if (data.selected?.length) {
        selectedItems = data.selected.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        if (page === 1) {
          setSelectedFilter(selectedItems);
        }
      }

      // set((prevData) =>
      //   !append ? [...prevData, ...formattedData, ...selectedItems] : formattedData
      // );

      // const dataArr = json?.filter_data.map((el) => ({
      //   label: el.name,
      //   value: el.id,
      // }));
      if (page > 1) {
        set((prev) => [...prev, ...formattedData]);
      } else {
        set(formattedData);
      }
    })
    .catch(handleRequestError);
};

// Multon bannerItems
export const fetchFilterBannerItems = ({
  selectedSpace,
  page = 1,
  set,
  selectedCategory,
  selectedBrand,
  selectedProduct,
  searchParam = null,
  setSelectedFilter,
  bannerId,
  date = [],
  filter,
  selected_id_list,
  setTotal
}) => {
  if (bannerId) {

    let url = `${OlegHttps}/api/v1/multon/media/banner_items/filter/${filter}`;

    let [date_from, date_to] = date;

    const selectedIds =
      selected_id_list && selected_id_list.length > 0
        ? selected_id_list.flatMap((id) =>
          typeof id === 'string' ? id.split(';') : id
        )
        : [];

    const body = JSON.stringify({
      search_param: searchParam.length < 1 ? null : searchParam,
      selected_id_list: selectedIds?.[0] ? selectedIds : [],
      brand_name: getValueMultiFilter(selectedBrand),
      category_name: getValueMultiFilter(selectedCategory),
      product_name: getValueMultiFilter(selectedProduct),
      limit: 50,
      page,
      banner_id: bannerId,
      date_from: dayjs(date_from).format('YYYY-MM-DD'),
      date_to: dayjs(date_to).format('YYYY-MM-DD'),
    });

    const headers = {
      ...currentHeaders,
      space: selectedSpace,
    };

    fetch(url, { body, method: 'POST', headers })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        const data = json
        if (setTotal && json?.total) setTotal(json?.total)
        const formattedData = data.filter_data?.map((item) => ({
          label: item.name,
          value: item.id,
        }));

        let selectedItems = []

        if (data.selected?.length) {
          selectedItems = data.selected.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          if (page === 1) {
            setSelectedFilter(selectedItems);
          }
        }
        if (page > 1) {
          set((prev) => [...prev, ...formattedData]);
        } else {
          set(formattedData);
        }
      })
      .catch(handleRequestError);
  }
};

export const fetchCampaignFilter = ({
  selectedSpace,
  selectedApi,
  selectedCategory,
  selectedBrand,
  selectedProduct,
  selectedShop,
  selectedCampaign,
  dateFrom,
  dateTo,
  page = 1,
  setCampaignData,
  searchParam = null,
  type = 'union',
  controller,
  setTotal
}) => {

  let url = `${OlegHttps}/api/v2/filter/product/campaing_id?filter_type=${type}`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    api_id_list: getValueMultiFilter(selectedApi),
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    product_id_list: getValueMultiFilter(selectedProduct),
    shop_id_list: getValueMultiFilter(selectedShop),
    campaign_id_list: getValueMultiFilter(selectedCampaign),
    date_from: dayjs(dateFrom).format('YYYY-MM-DD'),
    date_to: dayjs(dateTo).format('YYYY-MM-DD'),
    page,
    limit: 50,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      const dataArr = (json?.filter_data || json).map(({ id, name }) => ({
        label: name,
        value: id,
      }));
      if (page > 1) {
        setCampaignData((prev) => [...prev, ...dataArr]);
      } else {
        setCampaignData([...dataArr]);
      }
    })
    .catch(handleRequestError);

};

export const fetchWarehouseFilter = ({
  selectedSpace,
  selectedApi,
  selectedCategory,
  selectedBrand,
  selectedProduct,
  selectedShop,
  selectedCampaign,
  dateFrom,
  dateTo,
  page = 1,
  setWarehouseData,
  searchParam = null,
  type = 'union',
  controller,
  setTotal
}) => {

  let url = `${OlegHttps}/api/v2/filter/product/warehouse?filter_type=${type}`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    api_id_list: getValueMultiFilter(selectedApi),
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    product_id_list: getValueMultiFilter(selectedProduct),
    shop_id_list: getValueMultiFilter(selectedShop),
    campaign_id_list: getValueMultiFilter(selectedCampaign),
    date_from: dayjs(dateFrom).format('YYYY-MM-DD'),
    date_to: dayjs(dateTo).format('YYYY-MM-DD'),
    page,
    limit: 50,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      const dataArr = (json?.filter_data || json).map(({ id, name }) => ({
        label: name,
        value: id,
      }));
      if (page > 1) {
        setWarehouseData((prev) => [...prev, ...dataArr]);
      } else {
        setWarehouseData([...dataArr]);
      }
    })
    .catch(handleRequestError);
};

export const fetchProductFilter = ({
  selectedCategory,
  selectedBrand,
  selectedApi,
  page = 1,
  setProductsData,
  searchParam = null,
  selectedSpace,
  setTotal
}) => {
  let url = `${OlegHttps}/api/v2/filter/product/product?filter_type=union`;

  let api_id_list;

  if (selectedApi?.length > 0) {
    api_id_list = selectedApi?.map((el) => el.value);
  } else {
    api_id_list = ['all'];
  }
  if (selectedApi?.value) {
    api_id_list = [selectedApi?.value];
  }

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    api_id_list,
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    product_id_list: ['all'],
    page,
    limit: 50,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      const dataArr = (json?.filter_data || json)?.map((el) => ({ label: el.name, value: el.id }));
      if (page > 1) {
        setProductsData((prev) => [...prev, ...dataArr]);
      } else {
        setProductsData([...dataArr]);
      }
    })
    .catch(handleRequestError);
};

export const fetchAdvCampaignFilter = ({
  controller,
  selectedSpace,
  page = 1,
  selectedApi,
  selectedCategory,
  selectedBrand,
  selectedShop,
  selectedCampaign,
  searchParam = null,
  selected_id_list,
  set,
  setTotal
}) => {
  let url = `${OlegHttps}/api/v3/filter/campaign_advertising`;

  const selectedIds =
    selected_id_list && selected_id_list.length > 0
      ? selected_id_list.flatMap((id) =>
        typeof id === 'string' ? id.split(';') : id
      )
      : [];

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    api_id_list: getValueMultiFilter(selectedApi),
    shop_id_list: getValueMultiFilter(selectedShop),
    campaign_id_list: getValueMultiFilter(selectedCampaign),
    limit: 50,
    selected_id_list: selectedIds?.[0] ? selectedIds : [],
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = json?.filter_data.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError)
};

export const fetchOrderSuperStatusFilter = ({
  controller = new AbortController(),
  selectedSpace,
  page = 1,
  selectedApi,
  setSuperStatusData,
  selectedCategory,
  selectedBrand,
  selectedShop,
  searchParam = null,
  dateFrom,
  dateTo,
  setTotal
}) => {
  let url = `${OlegHttps}/api/v2/filter/product/super_status`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    api_id_list: getValueMultiFilter(selectedApi),
    shop_id_list: getValueMultiFilter(selectedShop),
    warehouse_id: ['all'],
    limit: 50,
    page,
    date_from: dayjs(dateFrom).format('YYYY-MM-DD'),
    date_to: dayjs(dateTo).format('YYYY-MM-DD'),
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      setDataFromJson(
        (json?.filter_data || json)?.map((el) => ({ ...el, id: String(el?.id) })),
        page,
        setSuperStatusData
      )
    })
    .catch(handleRequestError)
};

export const fetchAdvCampaignTypeFilter = ({
  controller,
  selectedSpace,
  page = 1,
  selectedApi,
  selectedCategory,
  selectedBrand,
  selectedShop,
  searchParam = null,
  dateFrom,
  dateTo,
  selected_id_list,
  set,
  setTotal
}) => {
  let url = `${OlegHttps}/api/v3/filter/campaign_type_advertising`;

  const selectedIds =
    selected_id_list && selected_id_list.length > 0
      ? selected_id_list.flatMap((id) =>
        typeof id === 'string' ? id.split(';') : id
      )
      : [];

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    api_id_list: getValueMultiFilter(selectedApi),
    shop_id_list: getValueMultiFilter(selectedShop),
    warehouse_id: ['all'],
    limit: 50,
    page,
    date_from: msToLocalDate(dateFrom),
    date_to: msToLocalDate(dateTo),
    selected_id_list: selectedIds?.[0] ? selectedIds : []
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = json?.filter_data.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError)
};

export const fetchAdvStatusFilter = ({
  controller,
  selectedSpace,
  page = 1,
  selectedApi,
  set,
  selectedCategory,
  selectedBrand,
  selectedShop,
  searchParam = null,
  dateFrom,
  dateTo,
  selected_id_list,
  setTotal
}) => {
  let url = `${OlegHttps}/api/v3/filter/status_advertising`;

  const selectedIds =
    selected_id_list && selected_id_list.length > 0
      ? selected_id_list.flatMap((id) =>
        typeof id === 'string' ? id.split(';') : id
      )
      : [];

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    api_id_list: getValueMultiFilter(selectedApi),
    shop_id_list: getValueMultiFilter(selectedShop),
    warehouse_id: ['all'],
    limit: 50,
    page,
    date_from: dayjs(dateFrom).format('YYYY-MM-DD'),
    date_to: dayjs(dateTo).format('YYYY-MM-DD'),
    selected_id_list: selectedIds?.[0] ? selectedIds : [],
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = json?.filter_data.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError)
};

// !!!!!!!!!!!!!!!!!!!!!

// Фильтр для мп, 
export const fetchFilterV3 = ({
  selectedSpace,
  controller,
  page = 1,
  selectedMP,
  selectedApi,
  selectedBrand,
  selectedCategory,
  selected_id_list = [],
  searchParam = '',
  setTotal,
  dateFrom,
  dateTo,
  set, 
  filter = '',
  excludeMP // исключить озон
}) => {
  let url = `https://apps0.ecomru.ru:4449/v3/filter/${filter}`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    date_from: dateFrom ? msToLocalDate(dateFrom) : undefined,
    date_to: dateTo ? msToLocalDate(dateTo) : undefined,
    api_id_list: getValueMultiFilter(selectedApi),
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    mp_id_list: (excludeMP && selectedMP?.[0]?.value == 'all') ? [3, 2] : getValueMultiFilter(selectedMP),
    selected_id_list,
    limit: 50,
    page,
  });

  const headers = { ...currentHeaders, space: selectedSpace };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      setDataFromJson((json?.filter_data || json), page, set)
    })
    .catch(handleRequestError);
};

export const fetchMPApiFilter = ({
  selectedSpace,
  controller,
  page = 1,
  selectedApi,
  selectedMP,
  withAll,
  setApiData,
  searchParam = '',
  setTotal
}) => {
  let url = `${KonstantinMasterHttps}/mp-products/filters/api-ids`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? '' : searchParam,
    api_id_list: getValueMultiFilter(selectedApi),
    mp_id_list: ['all'],
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      setDataFromJson((json?.filter_data || json), page, setApiData, withAll)
    })
    .catch(handleRequestError);
};

export const fetchMPCategoryFilter = ({
  selectedSpace,
  controller,
  page = 1,
  selectedApi,
  selectedBrand,
  setCategoryData,
  searchParam = '',
  setTotal
}) => {

  let url = `${KonstantinMasterHttps}/mp-products/filters/categories`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? '' : searchParam,
    api_id_list: getValueMultiFilter(selectedApi),
    brand_id_list: getValueMultiFilter(selectedBrand),
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      setDataFromJson((json?.filter_data || json), page, setCategoryData, true)
    })
    .catch(handleRequestError);
};

export const fetchMPBrandFilter = ({
  selectedSpace,
  controller,
  page = 1,
  setBrandData,
  selectedApi,
  searchParam = '',
  selectedCategory,
  setTotal
}) => {
  let url = `${KonstantinMasterHttps}/mp-products/filters/brands`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? '' : searchParam,
    api_id_list: getValueMultiFilter(selectedApi),
    category_id_list: getValueMultiFilter(selectedCategory),
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      setDataFromJson((json?.filter_data || json), page, setBrandData, true)
    })
    .catch(handleRequestError);
};

export const fetchMPOfferIdFilter = ({
  selectedSpace,
  controller,
  page = 1,
  selectedBrand,
  selectedApi,
  setOfferIdData,
  searchParam = '',
  selectedCategory,
  setTotal
}) => {

  let url = `${KonstantinMasterHttps}/mp-products/filters/offer-id-name`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? '' : searchParam,
    api_id_list: getValueMultiFilter(selectedApi),
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      setDataFromJson((json?.filter_data || json), page, setOfferIdData, true)
    })
    .catch(handleRequestError);
};

export const fetchMasterCategoryFilter = ({
  selectedSpace,
  page = 1,
  selectedApi,
  selectedBrand,
  setCategoryData,
  searchParam = '',
  withAll = true,
  controller,
  setTotal
}) => {

  let url = `${KonstantinMasterHttps}/master-products/filters/categories`;

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? '' : searchParam,
    api_id_list: getValueMultiFilter(selectedApi),
    category_id_list: ['all'],
    brand_id_list: getValueMultiFilter(selectedBrand),
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      setDataFromJson((json?.filter_data || json), page, setCategoryData, withAll)
    })
    .catch(handleRequestError);
};

export const fetchMasterBrandFilter = ({
  selectedSpace,
  page = 1,
  setBrandData,
  selectedApi,
  searchParam = '',
  selectedCategory,
  selectedBrand,
  controller,
  setTotal
}) => {
  let url = `${KonstantinMasterHttps}/master-products/filters/brands`;

  let api_id_list;

  if (selectedApi?.length > 0) {
    api_id_list = selectedApi?.map((el) => el.value);
  } else {
    api_id_list = ['all'];
  }
  if (selectedApi?.value) {
    api_id_list = [selectedApi?.value];
  }

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? '' : searchParam,
    api_id_list,
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    product_id_list: ['all'],
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      setDataFromJson((json?.filter_data || json), page, setBrandData, true)
    })
    .catch(handleRequestError);
};

export const fetchMasterOfferIdFilter = ({
  selectedSpace,
  page = 1,
  selectedBrand,
  selectedApi,
  setOfferIdData,
  searchParam = '',
  selectedCategory,
  setTotal
}) => {
  let url = `${KonstantinMasterHttps}/master-products/filters/offer-id-name`;

  let api_id_list;

  if (selectedApi?.length > 0) {
    api_id_list = selectedApi?.map((el) => el.value);
  } else {
    api_id_list = ['all'];
  }
  if (selectedApi?.value) {
    api_id_list = [selectedApi?.value];
  }

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? '' : searchParam,
    api_id_list,
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    product_id_list: ['all'],
    limit: 50,
    page,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      setDataFromJson((json?.filter_data || json), page, setOfferIdData, true)
    })
    .catch(handleRequestError);
};

export const fetchFeedbacksCategoryFilter = ({
  selectedSpace,
  dateFrom,
  dateTo,
  allPeriod = false,
  selectedApi,
  selectedBrand,
  selectedCategory,
  pageValue = 'feedbacks',
  setCategoryData,
  page = 1,
  searchParam = null,
  type = 'union',
  setTotal
}) => {
  if ((dateFrom !== '') & (dateTo !== '')) {
    let url = `${KonstantinMasterHttps}/wb/${pageValue}/filters/categories?filter_type=${type}`;

    let api_id_list;

    if (selectedApi?.length > 0) {
      api_id_list = selectedApi.map((el) => el.value);
    } else {
      api_id_list = ['all'];
    }
    if (selectedApi?.value) {
      api_id_list = [selectedApi?.value];
    }

    const body = JSON.stringify({
      search_param: searchParam.length < 1 ? '' : searchParam,
      api_id_list,
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      product_valuation_list: ['all'],
      date_from: allPeriod ? new Date(0) : dayjs(dateFrom).format('YYYY-MM-DD'),
      date_to: dayjs(dateTo).format('YYYY-MM-DD'),
      page,
      limit: 50,
    });

    const headers = {
      ...currentHeaders,
      space: selectedSpace,
    };

    fetch(url, { body, method: 'POST', headers })
      .then((res) => res.json())
      .then((json) => {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = (json?.filter_data || json)?.map((el) => ({
          label: `${el.name}`,
          value: el.id,
        }));
        if (page > 1) {
          setCategoryData((prev) => [...prev, ...dataArr]);
        } else {
          setCategoryData([...dataArr]);
        }
      })
      .catch(handleRequestError);
  }
};

export const fetchFeedbacksBrandFilter = ({
  selectedSpace,
  dateFrom,
  dateTo,
  allPeriod = false,
  selectedApi,
  selectedCategory,
  selectedBrand,
  setBrandData,
  page = 1,
  searchParam = null,
  pageValue = 'feedbacks',
  setTotal
}) => {
  if ((dateFrom !== '') & (dateTo !== '')) {
    let url = `${KonstantinMasterHttps}/wb/${pageValue}/filters/brands`;

    let api_id_list;

    if (selectedApi?.length > 0) {
      api_id_list = selectedApi.map((el) => el.value);
    } else {
      api_id_list = ['all'];
    }
    if (selectedApi?.value) {
      api_id_list = [selectedApi?.value];
    }

    const body = JSON.stringify({
      search_param: searchParam.length < 1 ? '' : searchParam,
      api_id_list,
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      product_valuation_list: ['all'],
      date_from: allPeriod ? new Date(0) : dayjs(dateFrom).format('YYYY-MM-DD'),
      date_to: dayjs(dateTo).format('YYYY-MM-DD'),
      page,
      limit: 50,
    });

    const headers = {
      ...currentHeaders,
      space: selectedSpace,
    };

    fetch(url, { body, method: 'POST', headers })
      .then((res) => res.json())
      .then((json) => {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = (json?.filter_data || json)?.map((el) => ({
          label: `${el.name}`,
          value: el.id,
        }));
        if (page > 1) {
          setBrandData((prev) => [...prev, ...dataArr]);
        } else {
          setBrandData([...dataArr]);
        }
      })
      .catch(handleRequestError);
  }
};

export const fetchCompetitorsFilter = ({
  selectedSpace,
  type,
  page = 1,
  setApiData,
  searchParam = null,
  setTotal
}) => {
  let url = `${OlegHttps}/api/v1/filter/competitors/type_${type}/shop`;


  const body = JSON.stringify({
    shop_id_list: ['all'],
    brand_id_list: ['all'],
    category_id_list: ['all'],
    seller_id_list: ['all'],
    super_id_list: ['all'],
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers })
    .then((res) => res.json())
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      const dataArr = (json?.filter_data || json).map((el) => ({
        label: el.name ? el.name : 'Не указано',
        value: el.id,
      }));
      if (page > 1) {
        setApiData((prev) => [...prev, ...dataArr]);
      } else {
        setApiData([...dataArr]);
      }
    })
    .catch(handleRequestError);
};

const fetchCompetitorsFilterInternal = ({
  selectedSpace,
  url,
  body,
  page = 1,
  setData,
  mapFunc,
  errorCallback,
  cleanupCallback,
  emptyResponseCallback,
  setTotal
}) => {
  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { headers, method: 'POST', body })
    .then((response) => {
      if (response.status === 204) {
        if (typeof emptyResponseCallback === 'function')
          emptyResponseCallback();
        return [];
      }
      if (response.status !== 200)
        throw new Error('bad competitors brand response');
      return response.json();
    })
    .then((json) => {
      if (setTotal && json?.total) setTotal(json?.total)
      setDataFromJson((json?.filter_data || json), page, setData, true, mapFunc)
    })
    .catch(handleRequestError)
    .finally(() =>
      typeof cleanupCallback === 'function' ? cleanupCallback() : {}
    );
};

export const fetchCompetitorsBrandFilter = ({
  selectedSpace,
  page = 1,
  limit = 50,
  searchParam = null,
  setData,
  mapFunc,
  errorCallback,
  cleanupCallback,
  emptyResponseCallback,
  setTotal
}) => {
  const body = JSON.stringify({
    search_param: searchParam,
    page,
    limit,
  });

  fetchCompetitorsFilterInternal({
    selectedSpace,
    url: `${OlegHttps}/api/v1/filter/competitors/brand`,
    page,
    body,
    setData,
    mapFunc,
    errorCallback,
    cleanupCallback,
    emptyResponseCallback,
    setTotal
  });
};

export const fetchCompetitorsSellerFilter = ({
  selectedSpace,
  page = 1,
  limit = 50,
  searchParam,
  setData,
  mapFunc,
  errorCallback,
  cleanupCallback,
  emptyResponseCallback,
  setTotal
}) => {
  const body = JSON.stringify({
    search_param: searchParam,
    page,
    limit,
  });

  fetchCompetitorsFilterInternal({
    selectedSpace,
    url: `${OlegHttps}/api/v1/filter/competitors/seller`,
    page,
    body,
    setData,
    mapFunc,
    errorCallback,
    cleanupCallback,
    emptyResponseCallback,
    setTotal
  });
};

export const fetchCompetitorsLinkBrandFilter = ({
  selectedSpace,
  page = 1,
  limit = 50,
  searchParam = null,
  shopData,
  selectedShop,
  categoryData,
  selectedCategory,
  setData,
  mapFunc,
  errorCallback,
  cleanupCallback,
  setTotal
}) => {
  if (!shopData?.length || !categoryData.length) {
    console.warn('no shop or category data for brand filter is provided');
    return;
  }

  const body = JSON.stringify({
    search_param: searchParam,
    page,
    limit,
    shop_name_list: selectedShop?.length
      ? selectedShop.map((el) => (el.label === 'Все' ? 'all' : el.label))
      : shopData.map((el) => (el.label === 'Все' ? 'all' : el.value)),
    category_name_list: selectedCategory?.length
      ? selectedCategory.map((el) => (el.label === 'Все' ? 'all' : el.label))
      : categoryData.map((el) => (el.label === 'Все' ? 'all' : el.value)),
    brand_name_list: ['all'],
  });

  fetchCompetitorsFilterInternal({
    selectedSpace,
    url: `${OlegHttps}/api/v1/filter/competitors/link/brand`,
    page,
    body,
    setData,
    mapFunc,
    errorCallback,
    cleanupCallback,
    setTotal
  });
};

export const fetchCompetitorsLinkCategoryFilter = ({
  selectedSpace,
  page = 1,
  limit = 50,
  searchParam = null,
  shopData,
  selectedShop,
  setData,
  mapFunc,
  errorCallback,
  cleanupCallback,
  setTotal
}) => {
  if (!shopData.length) {
    console.warn('no shop data for category filter is provided');
    return;
  }

  const body = JSON.stringify({
    search_param: searchParam,
    page,
    limit,
    shop_name_list: selectedShop?.length
      ? selectedShop.map((el) => (el.label === 'Все' ? 'all' : el.label))
      : shopData.map((el) => (el.label === 'Все' ? 'all' : el.value)),
    category_name_list: ['all'],
    brand_name_list: ['all'],
  });

  fetchCompetitorsFilterInternal({
    selectedSpace,
    url: `${OlegHttps}/api/v1/filter/competitors/link/category`,
    page,
    body,
    setData,
    mapFunc,
    errorCallback,
    cleanupCallback,
    setTotal
  });
};

export const fetchCompetitorsLinkShopFilter = ({
  selectedSpace,
  page = 1,
  limit = 50,
  searchParam = null,
  setData,
  mapFunc,
  errorCallback,
  cleanupCallback,
  setTotal
}) => {
  const body = JSON.stringify({
    search_param: searchParam,
    page,
    limit,
    shop_name_list: ['all'],
    category_name_list: ['all'],
    brand_name_list: ['all'],
  });

  fetchCompetitorsFilterInternal({
    selectedSpace,
    url: `${OlegHttps}/api/v1/filter/competitors/link/shop`,
    page,
    body,
    setData,
    mapFunc,
    errorCallback,
    cleanupCallback,
    setTotal
  });
};

export const fetchCompetitor2CategoryFilter = ({
  selectedSpace,
  type,
  apiData,
  selectedApi,
  setCategoryData,
  page = 1,
  searchParam = null,
  setTotal
}) => {
  if (apiData.length > 0) {
    let url = `${OlegHttps}/api/v1/filter/competitors/type_${type}/category`;

    const body = JSON.stringify({
      shop_id_list: getValueMultiFilter(selectedApi),
      category_id_list: ['all'],
      brand_id_list: ['all'],
      seller_id_list: ['all'],
      page,
      limit: 50,
    });

    const headers = {
      ...currentHeaders,
      space: selectedSpace,
    };

    fetch(url, { body, method: 'POST', headers })
      .then((res) => res.json())
      .then((json) => {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = (json?.filter_data || json).map((el) => ({
          label: el.name ? el.name : 'Не указано',
          value: el.id,
        }));
        if (page > 1) {
          setCategoryData((prev) => [...prev, ...dataArr]);
        } else {
          setCategoryData([...dataArr]);
        }
      })
      .catch(handleRequestError);
  }
};

export const fetchCompetitor2BrandFilter = ({
  selectedSpace,
  type,
  apiData,
  categoryData,
  selectedCategory,
  selectedApi,
  page = 1,
  setBrandData,
  setTotal
}) => {
  if ((apiData.length > 0) & (categoryData.length > 0)) {
    let url = `${OlegHttps}/api/v1/filter/competitors/type_${type}/brand`;

    const body = JSON.stringify({
      shop_id_list: getValueMultiFilter(selectedApi),
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: ['all'],
      seller_id_list: ['all'],
    });

    const headers = {
      ...currentHeaders,
      space: selectedSpace,
    };

    fetch(url, { body, method: 'POST', headers })
      .then((res) => res.json())
      .then((json) => {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = (json?.filter_data || json).map((el) => ({
          label: el.name ? el.name : 'Не указано',
          value: el.id,
        }));
        if (page > 1) {
          setBrandData((prev) => [...prev, ...dataArr]);
        } else {
          setBrandData([...dataArr]);
        }
      })
      .catch(handleRequestError);
  }
};

export const fetchCompetitor2ProductFilter = ({
  selectedSpace,
  type,
  apiData,
  selectedCategory,
  selectedBrand,
  selectedApi,
  page = 1,
  setProductsData,
  setTotal
}) => {
  if (apiData.length > 0) {
    let url = `${OlegHttps}/api/v1/filter/competitors/type_${type}/seller`;

    const body = JSON.stringify({
      shop_id_list: getValueMultiFilter(selectedApi),
      brand_id_list: getValueMultiFilter(selectedBrand),
      category_id_list: getValueMultiFilter(selectedCategory),
      seller_id_list: ['all'],
      page,
      limit: 50,
    });

    const headers = {
      ...currentHeaders,
      space: selectedSpace,
    };

    fetch(url, { body, method: 'POST', headers })
      .then((res) => res.json())
      .then((json) => {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = (json?.filter_data || json).map((el) => ({
          label: el.name ? el.name : 'Не указано',
          value: el.id,
        }));
        if (page > 1) {
          setProductsData((prev) => [...prev, ...dataArr]);
        } else {
          setProductsData([...dataArr]);
        }
      })
      .catch(handleRequestError);
  }
};

export const fetchWarehouseWarehouseFilter = ({
  selectedSpace,
  apiData,
  selectedApi,
  setWarehouseData,
  page = 1,
  setTotal
}) => {
  if (apiData.length > 0) {
    let url = `${OlegHttps}/api/v1/filter/warehouse/warehouse?filter_type=union`;

    let api_id_list;

    if (selectedApi.length > 0) {
      api_id_list = selectedApi.map((el) => el.value);
    } else {
      api_id_list = apiData.map((el) => el.value);
    }

    const body = JSON.stringify({
      api_id_list: getValueMultiFilter(selectedApi),
      limit: 50,
      page,
    });

    const headers = {
      ...currentHeaders,
      space: selectedSpace,
    };

    fetch(url, { body, method: 'POST', headers })
      .then((res) => res.json())
      .then((json) => {
        if (setTotal && json?.total) setTotal(json?.total)
        setDataFromJson((json?.filter_data || json), page, setWarehouseData, true)
      })
      .catch(handleRequestError);
  }
};

// Заказы
// !!
export const fetchOrdersFilter = ({
  selectedSpace,
  page = 1,
  setData,
  searchParam = null,
  type = 'ozon',
  target = 'api_id',
  selectedApi,
  selectedBrand,
  selectedCategory,
  selectedWarehouse,
  dateFrom,
  dateTo,
  withAll = true,
  abortController = new AbortController(),
  setTotal
}) => {
  let url = `${ArtemOrdersHttps}/get-postings/filter/${target}?filter_type=${type}`;

  let api_id;
  let category;
  let brand;
  let warehouse;

  if (selectedApi?.value) {
    api_id = selectedApi?.value;
  }

  if (selectedCategory?.length > 0) {
    category = selectedCategory?.value;
  } else {
    category = 'all';
  }

  if (selectedBrand?.length > 0) {
    brand = selectedBrand?.value;
  } else {
    brand = 'all';
  }

  if (selectedWarehouse?.length > 0) {
    warehouse = selectedWarehouse.value;
  } else {
    warehouse = 'all';
  }

  const body = JSON.stringify({
    search_param: searchParam.length < 1 ? null : searchParam,
    api_id,
    brand,
    category,
    warehouse,
    limit: 50,
    page,
    date_from: dateFrom
      ? new Date(dateFrom)?.toISOString().split('T')?.[0]
      : null,
    date_to: dateTo ? new Date(dateTo)?.toISOString().split('T')?.[0] : null,
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
    .then((res) => res.json())
    .then(({ options }) => {
      if (setTotal && options?.total) setTotal(options?.total)
      setDataFromJson(options, page, setData, withAll, ({ name, id }) => ({
        label: name,
        value: id,
      }));
    })
    .catch(handleRequestError);
};

// Заказы

export const fetchOrdersFilterNew = ({
  controller,
  searchParam = null,
  page = 1,
  set,
  selectedApi = [],
  selectedCategory = [],
  selectedBrand = [],
  selectedProduct = [],
  selectedMarketplace = [],
  selectedWarehouse = [],
  dateFrom,
  dateTo,
  selectedSpace,
  selected_id_list,
  filter,
  setTotal
}) => {

  let url = `https://apps0.ecomru.ru:4449/v3.1/filter/${filter}`

  let product_id_list

  if (selectedProduct?.length > 0) {
    product_id_list = selectedProduct.map((el) => el.value);
  } else {
    product_id_list = ['all'];
  }

  const body = JSON.stringify({
    search_param: searchParam,
    api_id_list: getValueMultiFilter(selectedApi),
    category_id_list: getValueMultiFilter(selectedCategory),
    brand_id_list: getValueMultiFilter(selectedBrand),
    selected_id_list,
    mp_id_list: getValueMultiFilter(selectedMarketplace),
    warehouse_id_list: getValueMultiFilter(selectedWarehouse),
    limit: 50,
    page,
    date_from: dayjs(dateFrom).format('YYYY-MM-DD'),
    date_to: dayjs(dateTo).format('YYYY-MM-DD'),
  });

  const headers = {
    ...currentHeaders,
    space: selectedSpace,
  };

  fetch(url, { body, method: 'POST', headers, signal: controller?.signal })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const err = await res.json();
        throw new Error(JSON.stringify(err));
      }
    })
    .then((json) => {
      if (json) {
        if (setTotal && json?.total) setTotal(json?.total)
        const dataArr = json?.filter_data.map((el) => ({
          label: el.name,
          value: el.id,
        }));
        if (page > 1) {
          set((prev) => [...prev, ...dataArr]);
        } else {
          set([...dataArr]);
        }
      }
    })
    .catch(handleRequestError)
};
